<template>
  <span :class="getReportTrendClass(trend)">{{ formatReportTrend(trend) }}</span>
</template>

<script setup lang="ts">
import { getReportTrendClass, formatReportTrend } from "@/_helpers/reports";

defineProps<{ trend: number }>();
</script>
